export default "__VITE_ASSET__$KU7JqO8__"